import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import React, {Component} from 'react';
import styled from 'styled-components';

import {Col, RCol, Row} from './Grid';
import {HeadlineH1, HeadlineH3} from './text/Headlines';
import {ROLE_ADMIN} from '../constants/userConstants';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import DeleteModal from './DeleteModal';
import ErrorMessage from './ErrorMessage';
import WindowParams from './WindowParams';
import config from '../config';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';

const ImagePicker = styled.input`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0;
`;
const CurrentDoc = styled.div`
  padding-top: 15px;
`;

export async function uploadFile(file, token, windowId, type) {
  let data = new FormData();
  data.append('document', file);
  const url =
    config.apiUrl + '/upload?mediaType=document' + (windowId ? '&windowId=' + windowId : '') + `&type=${type}`;
  let headers = {Accept: 'application/json', authorization: `Bearer ${token}`};
  return fetch(url, {method: 'POST', headers, body: data});
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      winType: null,
      winClass: null,
      variation: null,
      uValueFrame: null,
      uValueGlass: null,
      windLoad: null,
      drivingRain: null,
      psiValue: null,
      rainRackType: null,
      coatingType: null,
      wingSeal: null,
      foldSeal: null,
      glassType: null,
      placeholder: null,
      rainRackProd: null,
      coatingProd: null,
      sealProd: null,
      profileDie: null,
      airPermeable: null,
      operateForce: null,
      mechanicalStress: null,
      thermalInsulation: null,
      soundInsulation: null,
      serialNumber: '',
      qualityReportNumber: '',
      height: '',
      width: '',
      completeSurface: '',
      validatedAtStr: null,
      document: null,
      drawing: null,
      showDeleteModal: false,
      ...filterOutNotDefinedValues(props.data.window),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {window} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(window)});
    }
  };
  _goBackToList = () => this.props.history.replace('/window');

  _renderHeadline = () => {
    if (this._isNew()) {
      return <span>Neues Fenster</span>;
    }
    return <span>Fenster bearbeiten</span>;
  };

  _isNew = () => !this.props.match.params.id;

  _handleDocumentSelection = ({target: {files}}) => {
    let file = files[0];
    let reader = new FileReader();
    reader.onload = ({target: {result}}) => {
      this.setState({documentToUpload: {file, src: result}});
    };
    reader.readAsDataURL(file);
  };

  _handleDrawingSelection = ({target: {files}}) => {
    let file = files[0];
    let reader = new FileReader();
    reader.onload = ({target: {result}}) => {
      this.setState({drawingToUpload: {file, src: result}});
    };
    reader.readAsDataURL(file);
  };

  _save = () => {
    let {documentToUpload, drawingToUpload, showDeleteModal, ...state} = filterOutNotDefinedValues(this.state);
    let windowId;
    this.props
      .save({...state})
      .then(result => {
        windowId = result.data.saveWindow._id;
        if (documentToUpload) {
          let {file} = documentToUpload;
          return uploadFile(file, this.props.user.token, windowId, 'document');
        }
      })
      .then(() => {
        if (drawingToUpload) {
          let {file} = drawingToUpload;
          return uploadFile(file, this.props.user.token, windowId, 'drawing');
        }
      })
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error sending the query', error);
      });
  };
  _validate = () =>
    this.props
      .validate({...this.state})
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error sending the query', error);
      });
  _delete = () =>
    this.props
      .delete({...this.state})
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error deleting the window', error);
      });
  _showDeleteModal = () => {
    this.setState({showDeleteModal: true});
  };
  _hideDeleteModal = () => {
    this.setState({showDeleteModal: false});
  };
  _handleChange = ({key, value}) => {
    this.setState({[key]: value});
  };
  _handleTextValueChange = (key, value) => {
    this.setState({[key]: value});
  };
  _renderCurrentDokument() {
    let {documentToUpload, document} = this.state;
    if (!(documentToUpload || document)) return <CurrentDoc>Kein Dokument ausgewählt</CurrentDoc>;
    if (documentToUpload) {
      return <CurrentDoc>Neues Dokument zum Speichern bereit: {documentToUpload.file.name}</CurrentDoc>;
    } else if (document) {
      return (
        <CurrentDoc>
          Aktuelles Dokument:{' '}
          <a href={document} target="_blank">
            {document}
          </a>
        </CurrentDoc>
      );
    }
  }
  _renderCurrentDrawing() {
    let {drawingToUpload, drawing} = this.state;
    if (!(drawingToUpload || drawing)) return <CurrentDoc>Kein Dokument ausgewählt</CurrentDoc>;
    if (drawingToUpload) {
      return <CurrentDoc>Neuer Schnitt zum Speichern bereit: {drawingToUpload.file.name}</CurrentDoc>;
    } else if (drawing) {
      return (
        <CurrentDoc>
          Aktueller Schnitt:{' '}
          <a href={drawing} target="_blank">
            {drawing}
          </a>
        </CurrentDoc>
      );
    }
  }
  render() {
    const {errors, validatedAtStr, _id} = this.state;
    const {user} = this.props;

    return (
      <div>
        <ErrorMessage errors={errors} />
        <TopBar>
          <Row>
            <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
              <HeadlineH1>{this._renderHeadline()}</HeadlineH1>
            </TopBarLeftCol>
            <RCol size={0.7}>
              <TopBarButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
              {user.role === ROLE_ADMIN && _id && (
                <FlatButton primary onClick={this._showDeleteModal} label="löschen" />
              )}
              {user.role === ROLE_ADMIN && !validatedAtStr && _id && (
                <TopBarButton primary onClick={this._validate} label="validieren" />
              )}
              <TopBarButton primary onClick={this._save} label="speichern" />
            </RCol>
          </Row>
        </TopBar>
        <WindowParams
          metas={this.props.data.allMetas}
          showAdd={true}
          handleChange={this._handleChange}
          handleTextValueChange={this._handleTextValueChange}
          {...this.state}
        />
        <Row style={{marginBottom: 100}}>
          <Col size={0.5}>
            <HeadlineH3>Dokument hochladen</HeadlineH3>
            <RaisedButton label="Dokument auswählen" labelPosition="before" containerElement="label">
              <ImagePicker
                type="file"
                onChange={this._handleDocumentSelection}
                accept="image/png,image/jpeg,image/gif,application/pdf"
              />
            </RaisedButton>
            {this._renderCurrentDokument()}
          </Col>
          <Col size={0.5}>
            <HeadlineH3>Schnitt hochladen</HeadlineH3>
            <RaisedButton label="Schnitt auswählen" labelPosition="before" containerElement="label">
              <ImagePicker
                type="file"
                onChange={this._handleDrawingSelection}
                accept="image/png,image/jpeg,image/gif,application/pdf"
              />
            </RaisedButton>

            {this._renderCurrentDrawing()}
          </Col>
        </Row>
        <DeleteModal open={this.state.showDeleteModal} onCancel={this._hideDeleteModal} onConfirm={this._delete} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WindowForm.js